import { Provider } from '@angular/core';

import { AuthFacade } from '@/app/core/auth';
import { REFRESH_TOKEN_CALLER, SESSION_EXPIRED_HANDLER } from '@/app/core/http';

export function provideAuthSession(): Provider[] {
  return [
    {
      provide: REFRESH_TOKEN_CALLER,
      useFactory: (facade: AuthFacade) => () => facade.refreshToken(),
      deps: [AuthFacade],
    },

    {
      provide: SESSION_EXPIRED_HANDLER,
      useFactory: (facade: AuthFacade) => () => facade.forceLogout('session-expired'),
      deps: [AuthFacade],
    },
  ];
}
